import {
  FILE_UPLOAD_LOADING,
  FILE_UPLOAD_SUCCESS,
  FILE_UPLOAD_ERROR,
} from "./constains";
import { _uploadMedia } from "./services";
import { errorParser } from "../../services/apiErrorParser";

const fileUploadStart = (data) => {
  return {
    type: FILE_UPLOAD_LOADING,
    payload: data,
  };
};
const fileUploadSuccess = (data) => {
  return {
    type: FILE_UPLOAD_SUCCESS,
    payload: data,
  };
};
const fileUploadFailure = (error) => {
  return {
    type: FILE_UPLOAD_ERROR,
    payload: error,
  };
};

export const fileUpload = (file) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(fileUploadStart(true));
    _uploadMedia(file)
      .then(async (res) => {
        await dispatch(fileUploadSuccess(res));
        resolve(res);
      })
      .catch(async (err) => {
        const parsedError = await errorParser.parseError(err);
        dispatch(fileUploadFailure(parsedError));
        reject(err);
      });
  });
};
